export default __webpack_public_path__ + "static/media/cc-by-nc-nd.7c02fe86.png";